export * from './divider.component'
export * from './divider.variants'
